<script lang="ts">
  import { session } from '@/lib/session.svelte';
  import { brandStore } from '@/lib/brandStore.svelte';
  import Header from '@/components/Header.svelte';
  import VehicleForm from '@/components/VehicleForm.svelte';
  import UploadScreen from '@/components/UploadScreen.svelte';
  import ArScreen from '@/components/ArScreen.svelte';
  import VideoAnalysisScreen from '@/components/VideoAnalysisScreen.svelte';
  import VideoResultsScreen from '@/components/VideoResultsScreen.svelte';
  import ResultsScreen from '@/components/ResultsScreen.svelte';
  import ScreenTransition from '@/components/ScreenTransition.svelte';
  import Spinner from '@/components/Spinner.svelte';
  import { navigateTo, goBack } from '@/lib/router';

  let spinnerVisible = $state(false);
  let spinnerText = $state('');

  function showSpinner(text: string) {
    spinnerText = text;
    spinnerVisible = true;
  }

  function hideSpinner() {
    spinnerVisible = false;
  }

  const currentScreen = $derived(session.currentScreen);
  const cfg = $derived(brandStore.config);
  const labels = $derived(brandStore.labels);

  const SCREEN_TITLES = $derived({
    vehicle: undefined as string | undefined,
    upload: labels?.uploadScreenTitle,
    ar: labels?.arModeTitle,
    results: labels?.resultsScreenTitle,
    video: 'Analise de Video',
    videoresults: 'Resultados do Video',
  });

  const SHOW_BACK = ['results', 'video', 'videoresults'];
  const SHOW_FOOTER = (s: string) => s !== 'ar';
  const IS_AR = (s: string) => s === 'ar';
</script>

<Header
  compact={currentScreen !== 'vehicle'}
  statusLabel=""
  title={SCREEN_TITLES[currentScreen]}
  showBack={SHOW_BACK.includes(currentScreen)}
  onBack={goBack}
/>

<main class="main">
  {#if currentScreen === 'vehicle'}
    <ScreenTransition>
      <VehicleForm />
    </ScreenTransition>
  {:else if currentScreen === 'upload'}
    <ScreenTransition>
      <UploadScreen />
    </ScreenTransition>
  {:else if currentScreen === 'ar'}
    <ScreenTransition>
      <ArScreen
        onResult={(cat, conf) => {
          session.setResults({
            category: cat,
            confidence: conf,
            scores: {},
            matches: [],
          });
          navigateTo('results');
        }}
      />
    </ScreenTransition>
  {:else if currentScreen === 'results'}
    <ScreenTransition>
      <ResultsScreen />
    </ScreenTransition>
  {:else if currentScreen === 'video'}
    <ScreenTransition>
      <VideoAnalysisScreen />
    </ScreenTransition>
  {:else if currentScreen === 'videoresults'}
    <ScreenTransition>
      <VideoResultsScreen />
    </ScreenTransition>
  {/if}
</main>

{#if SHOW_FOOTER(currentScreen)}
  <footer>
    <a href={cfg?.poweredBy.url ?? '#'} target="_blank" rel="noopener">
      {cfg?.poweredBy.name ?? 'AutoZ'}
    </a>
  </footer>
{/if}

<Spinner visible={spinnerVisible} text={spinnerText} />
